import colorsVars from 'styles/colors.module.scss';

const { statusSummaryGreen, statusSummaryRed, statusSummaryOrange } = colorsVars;

export const { todoCardBackground, doneCardBackground, inProgressCardBackground, notFoundBackground } = colorsVars;

export type Status = 'TODO' | 'DONE' | 'IN_PROGRESS' | 'NOT_STARTED' | 'COMPLETED';
export const getStatusColorHex = (status: Status): string => {
    switch (status) {
        case 'TODO':
            return todoCardBackground;
        case 'DONE':
            return doneCardBackground;
        case 'IN_PROGRESS':
            return inProgressCardBackground;
        case 'NOT_STARTED':
            return todoCardBackground;
        case 'COMPLETED':
            return doneCardBackground;
        default:
            return notFoundBackground;
    }
};
export const getStatusLabel = (param: Status | undefined) => {
    switch (param) {
        case 'TODO':
            return 'To Do';
        case 'DONE':
            return 'Done';
        case 'IN_PROGRESS':
            return 'In Progress';
        case 'NOT_STARTED':
            return 'To Do';
        case 'COMPLETED':
            return 'Done';
        default:
            return 'No Change';
    }
};
type StatusColor = 'TODO' | 'To Do' | 'DONE' | 'Done' | 'IN_PROGRESS' | 'In Progress' | 'NOT_STARTED' | 'COMPLETED';
export const getStatusColor = (param: StatusColor | undefined) => {
    switch (param) {
        case 'TODO':
        case 'To Do':
            return 'toDo';
        case 'DONE':
        case 'Done':
            return 'done';
        case 'IN_PROGRESS':
        case 'In Progress':
            return 'inProgress';
        case 'NOT_STARTED':
            return 'notStarted';
        case 'COMPLETED':
            return 'completed';
        default:
            return 'notFound';
    }
};
export const getStatusColorHexByLaneId = (laneId: string): string => {
    switch (laneId) {
        case '1':
            return todoCardBackground;
        case '2':
            return inProgressCardBackground;
        case '3':
            return doneCardBackground;
        default:
            return todoCardBackground;
    }
};

const STATUSES_TYPES = {
    AHEADOFSCHEDULE: 'AHEADOFSCHEDULE',
    BEHINDSCHEDULE: 'BEHINDSCHEDULE',
    ONSCHEDULE: 'ONSCHEDULE',
    SLIGHTLYBEHINDSCHEDULE: 'SLIGHTLYBEHINDSCHEDULE',
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    BEHIND: 'BEHIND',
    AHEAD: 'AHEAD',
};

const colorMapProgress = new Map();
colorMapProgress.set(STATUSES_TYPES.AHEADOFSCHEDULE, statusSummaryGreen);
colorMapProgress.set(STATUSES_TYPES.BEHINDSCHEDULE, statusSummaryRed);
colorMapProgress.set(STATUSES_TYPES.ONSCHEDULE, statusSummaryGreen);
colorMapProgress.set(STATUSES_TYPES.SLIGHTLYBEHINDSCHEDULE, statusSummaryOrange);
colorMapProgress.set(STATUSES_TYPES.BEHIND, statusSummaryRed);
colorMapProgress.set(STATUSES_TYPES.AHEAD, statusSummaryGreen);

const colorMapRisk = new Map();
colorMapRisk.set(STATUSES_TYPES.HIGH, statusSummaryRed);
colorMapRisk.set(STATUSES_TYPES.MEDIUM, statusSummaryOrange);
colorMapRisk.set(STATUSES_TYPES.LOW, statusSummaryGreen);

const colorMapQuality = new Map();
colorMapQuality.set(STATUSES_TYPES.HIGH, statusSummaryGreen);
colorMapQuality.set(STATUSES_TYPES.MEDIUM, statusSummaryOrange);
colorMapQuality.set(STATUSES_TYPES.LOW, statusSummaryRed);

const colorMapCriticalityAdherence = new Map();
colorMapCriticalityAdherence.set(STATUSES_TYPES.AHEADOFSCHEDULE, statusSummaryGreen);
colorMapCriticalityAdherence.set(STATUSES_TYPES.BEHINDSCHEDULE, statusSummaryRed);
colorMapCriticalityAdherence.set(STATUSES_TYPES.ONSCHEDULE, statusSummaryGreen);
colorMapCriticalityAdherence.set(STATUSES_TYPES.SLIGHTLYBEHINDSCHEDULE, statusSummaryOrange);
colorMapCriticalityAdherence.set(STATUSES_TYPES.BEHIND, statusSummaryRed);
colorMapCriticalityAdherence.set(STATUSES_TYPES.AHEAD, statusSummaryGreen);

const colorMapMilestoneAdherence = new Map();
colorMapMilestoneAdherence.set(STATUSES_TYPES.HIGH, statusSummaryRed);
colorMapMilestoneAdherence.set(STATUSES_TYPES.MEDIUM, statusSummaryOrange);
colorMapMilestoneAdherence.set(STATUSES_TYPES.LOW, statusSummaryGreen);

const colorMapProjecDuratioOverrun = new Map();
colorMapProjecDuratioOverrun.set(STATUSES_TYPES.HIGH, statusSummaryRed);
colorMapProjecDuratioOverrun.set(STATUSES_TYPES.MEDIUM, statusSummaryOrange);
colorMapProjecDuratioOverrun.set(STATUSES_TYPES.LOW, statusSummaryGreen);

const colorMapAllStatuses = new Map();
colorMapAllStatuses.set('Progress', colorMapProgress);
colorMapAllStatuses.set('Risk', colorMapRisk);
colorMapAllStatuses.set('Quality', colorMapQuality);
colorMapAllStatuses.set('Date', colorMapRisk);
colorMapAllStatuses.set('CriticalityAdherence', colorMapCriticalityAdherence);
colorMapAllStatuses.set('MilestoneAdherence', colorMapMilestoneAdherence);
colorMapAllStatuses.set('ProjecDuratioOverrun', colorMapProjecDuratioOverrun);

const getStatusAsKey = (string) => (string ? string.replace(/\s/g, '').toUpperCase() : '');
export const getColorFromStatus = (status, type) => colorMapAllStatuses.get(type).get(getStatusAsKey(status));
